import "@wordpress/block-library/build-style/style.css";
import "@wordpress/block-library/build-style/theme.css";

import Main from './_main';
import Top from './_top';
import Aboutus from './_aboutus';
import Business from './_business';
import Works from './_works';
import Contact from './_contact';

new Main();
new Top();
new Aboutus();
new Business();
new Works();
new Contact();